module.exports = __webpack_public_path__ + "static/media/t03kz.2028bee2.pdf";